// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/app-store-black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/app-store-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/swedish-flag.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-amusia {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-headline-logo-container {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.page-headline-logo {
  width: 44px;
  height: 44px;
}

.page-headline {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}

.page-headline-app-store-link {
  width: 120px;
  height: 42px;
  position: relative;
  cursor: pointer;
}

.page-headline-app-store-image {
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
}

.page-headline-app-store-image.default {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.page-headline-app-store-image.hover {
  opacity: 0;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.page-headline-app-store-link img.default,
.page-headline-app-store-link img.hover {
  transition: opacity 0.3s;
}

.page-headline-app-store-link:hover img.default {
  opacity: 0;
}

.page-headline-app-store-link:hover img.hover {
  opacity: 1;
}

.page-content {
  display: flex;
  padding: 4rem;
  flex-direction: column;
}

.content-row {
  display: flex;
  flex-direction: row;
  gap: 4rem;
}

.content-row.title {
  margin-bottom: 2rem;
}

.content-column {
  display: flex;
  flex-direction: column;
  gap: 4rem;
  justify-content: center;
}

.page-sheet,
.page-content,
.footer-content {
  max-width: 980px;
}
.footer-bottom {
  display: flex;
  justify-content: space-between;
}
.footer-bottom .flag-container {
  display: flex;
  gap: 2rem;
  align-items: center;
}
img.bottom-flag {
  width: 20px;
  height: 20px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.page-sheet {
  display: flex;
  flex-direction: row;
  background-color: var(--theme-dark-sheet-background-color);
  border-radius: var(--sheet-border-radius);
  color: var(--theme-dark-text-body-color);
  padding: 4rem;
  margin: 4rem;
  gap: 4rem;
  font-size: 16px;
}

.sheet-feature {
  display: flex;
  flex-direction: column;
}

.sheet-feature .sheet-feature-icon {
  width: 8rem;
  height: 8rem;
  padding: 2rem;
  display: flex;
  border-radius: 4rem;
  background-color: var(--theme-dark-button-background-color);
  align-self: center;
  margin-bottom: 1rem;
}

.sheet-feature .sheet-feature-icon img {
  width: 100%;
}

.sheet-feature-title {
  color: var(--theme-dark-sheet-text-title-color);
  align-self: center;
  margin-bottom: 2rem;
}

.page-footer {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: var(--theme-dark-sheet-background-color);
  color: var(--theme-dark-text-body-color);
  padding: 4rem;
  padding-top: 2rem;
  margin-top: 1rem;
}

.page-amusia .logo {
  width: 44px;
}

.page-amusia .headline {
  font-family: Monoton;
}

.page-amusia p,
.page-amusia li {
  font-size: 14px;
  font-weight: normal;
}

.text-gradient-mono-up {
  background: -webkit-linear-gradient(
    rgb(255, 255, 255, 1),
    rgb(255, 255, 255, 0.75)
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
}

.text-gradient {
  background: -webkit-linear-gradient(
    15deg,
    rgb(61, 245, 167),
    rgb(58, 133, 179),
    rgb(236, 55, 110),
    rgb(245, 176, 98)
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
}

.text-gradient-aurora {
  background: -webkit-linear-gradient(
    15deg,
    rgb(61, 245, 167),
    rgb(58, 133, 179)
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
}

.text-gradient-sunset {
  background: -webkit-linear-gradient(
    15deg,
    rgb(236, 55, 110),
    rgb(245, 176, 98)
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

h1,
h2,
h3 {
  color: var(--theme-dark-text-title-color);
  scroll-margin-top: 100px;
  font-weight: normal;
}

h1.no-margins {
  margin: 0;
}

.page-amusia h1.hero-title,
.page-amusia .hero-title-animation {
  font-size: 72px;
}

.page-amusia h1 {
  font-size: 24px;
}

.page-amusia h2 {
  font-size: 16px;
}

.page-amusia h3 {
  font-size: 14px;
}

@media only screen and (min-width: 0px) and (max-width: 550px) {
  form {
    width: 100%;
  }
  .form-buttons {
    flex-direction: column;
  }
  .page-amusia h1.hero-title {
    font-size: 36px !important;
  }

  .page-amusia h1 {
    font-size: 18px !important;
  }

  .page-amusia h2 {
    font-size: 14px;
  }

  .page-amusia h3 {
    font-size: 12px;
  }

  section.content-row {
    flex-direction: column-reverse;
  }

  .page-sheet {
    flex-direction: column;
  }
  .footer-bottom {
    flex-direction: column;
  }
}

.watch-promo-container {
  position: relative;
  height: 45rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.watch-promo-container .watch-video {
  height: 55%;
  border-radius: 2rem;
  overflow: hidden;
  position: absolute;
  z-index: 1;
}
.watch-promo-container .watch-video video {
  height: 100%;
}

.watch-promo-container .watch-frame {
  height: 100%;
  z-index: 2;
}

.phone-promo-container {
  position: relative;
  height: 45rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.phone-promo-container .phone-video {
  height: 91%;
  border-radius: 2rem;
  overflow: hidden;
  position: absolute;
  z-index: 1;
}
.phone-promo-container .phone-video video {
  height: 100%;
}

.phone-promo-container .phone-frame {
  height: 100%;
  z-index: 2;
}

.divider {
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  margin: 4rem 0 0;
}

.divider.top {
  margin-top: 4rem;
}

.divider.bottom {
  margin-bottom: 4rem;
}

.support-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4rem 0;
  gap: 2rem;
}

.support-title img {
  height: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/amusia/amusia.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,gDAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,gDAA2C;AAC7C;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;;;EAGE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gDAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0DAA0D;EAC1D,yCAAyC;EACzC,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2DAA2D;EAC3D,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,0DAA0D;EAC1D,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;;;GAGC;EACD,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE;;;;;;GAMC;EACD,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE;;;;GAIC;EACD,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE;;;;GAIC;EACD,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;;;EAGE,yCAAyC;EACzC,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,YAAY;AACd","sourcesContent":[".page-amusia {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.page-headline-logo-container {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.page-headline-logo {\n  width: 44px;\n  height: 44px;\n}\n\n.page-headline {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  align-items: center;\n}\n\n.page-headline-app-store-link {\n  width: 120px;\n  height: 42px;\n  position: relative;\n  cursor: pointer;\n}\n\n.page-headline-app-store-image {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.page-headline-app-store-image.default {\n  content: url(\"/public/app-store-black.svg\");\n}\n\n.page-headline-app-store-image.hover {\n  opacity: 0;\n  content: url(\"/public/app-store-white.svg\");\n}\n\n.page-headline-app-store-link img.default,\n.page-headline-app-store-link img.hover {\n  transition: opacity 0.3s;\n}\n\n.page-headline-app-store-link:hover img.default {\n  opacity: 0;\n}\n\n.page-headline-app-store-link:hover img.hover {\n  opacity: 1;\n}\n\n.page-content {\n  display: flex;\n  padding: 4rem;\n  flex-direction: column;\n}\n\n.content-row {\n  display: flex;\n  flex-direction: row;\n  gap: 4rem;\n}\n\n.content-row.title {\n  margin-bottom: 2rem;\n}\n\n.content-column {\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n  justify-content: center;\n}\n\n.page-sheet,\n.page-content,\n.footer-content {\n  max-width: 980px;\n}\n.footer-bottom {\n  display: flex;\n  justify-content: space-between;\n}\n.footer-bottom .flag-container {\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n}\nimg.bottom-flag {\n  width: 20px;\n  height: 20px;\n  content: url(\"/public/swedish-flag.svg\");\n}\n\n.page-sheet {\n  display: flex;\n  flex-direction: row;\n  background-color: var(--theme-dark-sheet-background-color);\n  border-radius: var(--sheet-border-radius);\n  color: var(--theme-dark-text-body-color);\n  padding: 4rem;\n  margin: 4rem;\n  gap: 4rem;\n  font-size: 16px;\n}\n\n.sheet-feature {\n  display: flex;\n  flex-direction: column;\n}\n\n.sheet-feature .sheet-feature-icon {\n  width: 8rem;\n  height: 8rem;\n  padding: 2rem;\n  display: flex;\n  border-radius: 4rem;\n  background-color: var(--theme-dark-button-background-color);\n  align-self: center;\n  margin-bottom: 1rem;\n}\n\n.sheet-feature .sheet-feature-icon img {\n  width: 100%;\n}\n\n.sheet-feature-title {\n  color: var(--theme-dark-sheet-text-title-color);\n  align-self: center;\n  margin-bottom: 2rem;\n}\n\n.page-footer {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  background-color: var(--theme-dark-sheet-background-color);\n  color: var(--theme-dark-text-body-color);\n  padding: 4rem;\n  padding-top: 2rem;\n  margin-top: 1rem;\n}\n\n.page-amusia .logo {\n  width: 44px;\n}\n\n.page-amusia .headline {\n  font-family: Monoton;\n}\n\n.page-amusia p,\n.page-amusia li {\n  font-size: 14px;\n  font-weight: normal;\n}\n\n.text-gradient-mono-up {\n  background: -webkit-linear-gradient(\n    rgb(255, 255, 255, 1),\n    rgb(255, 255, 255, 0.75)\n  );\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  -webkit-background-clip: text;\n}\n\n.text-gradient {\n  background: -webkit-linear-gradient(\n    15deg,\n    rgb(61, 245, 167),\n    rgb(58, 133, 179),\n    rgb(236, 55, 110),\n    rgb(245, 176, 98)\n  );\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  -webkit-background-clip: text;\n}\n\n.text-gradient-aurora {\n  background: -webkit-linear-gradient(\n    15deg,\n    rgb(61, 245, 167),\n    rgb(58, 133, 179)\n  );\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  -webkit-background-clip: text;\n}\n\n.text-gradient-sunset {\n  background: -webkit-linear-gradient(\n    15deg,\n    rgb(236, 55, 110),\n    rgb(245, 176, 98)\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\nh1,\nh2,\nh3 {\n  color: var(--theme-dark-text-title-color);\n  scroll-margin-top: 100px;\n  font-weight: normal;\n}\n\nh1.no-margins {\n  margin: 0;\n}\n\n.page-amusia h1.hero-title,\n.page-amusia .hero-title-animation {\n  font-size: 72px;\n}\n\n.page-amusia h1 {\n  font-size: 24px;\n}\n\n.page-amusia h2 {\n  font-size: 16px;\n}\n\n.page-amusia h3 {\n  font-size: 14px;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 550px) {\n  form {\n    width: 100%;\n  }\n  .form-buttons {\n    flex-direction: column;\n  }\n  .page-amusia h1.hero-title {\n    font-size: 36px !important;\n  }\n\n  .page-amusia h1 {\n    font-size: 18px !important;\n  }\n\n  .page-amusia h2 {\n    font-size: 14px;\n  }\n\n  .page-amusia h3 {\n    font-size: 12px;\n  }\n\n  section.content-row {\n    flex-direction: column-reverse;\n  }\n\n  .page-sheet {\n    flex-direction: column;\n  }\n  .footer-bottom {\n    flex-direction: column;\n  }\n}\n\n.watch-promo-container {\n  position: relative;\n  height: 45rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.watch-promo-container .watch-video {\n  height: 55%;\n  border-radius: 2rem;\n  overflow: hidden;\n  position: absolute;\n  z-index: 1;\n}\n.watch-promo-container .watch-video video {\n  height: 100%;\n}\n\n.watch-promo-container .watch-frame {\n  height: 100%;\n  z-index: 2;\n}\n\n.phone-promo-container {\n  position: relative;\n  height: 45rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.phone-promo-container .phone-video {\n  height: 91%;\n  border-radius: 2rem;\n  overflow: hidden;\n  position: absolute;\n  z-index: 1;\n}\n.phone-promo-container .phone-video video {\n  height: 100%;\n}\n\n.phone-promo-container .phone-frame {\n  height: 100%;\n  z-index: 2;\n}\n\n.divider {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n  margin: 4rem 0 0;\n}\n\n.divider.top {\n  margin-top: 4rem;\n}\n\n.divider.bottom {\n  margin-bottom: 4rem;\n}\n\n.support-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 4rem 0;\n  gap: 2rem;\n}\n\n.support-title img {\n  height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
